import MEmptyCommunity from './MEmptyCommunity.vue';

export { MEmptyCommunity };
export default MEmptyCommunity;
